document.addEventListener("DOMContentLoaded", function(){



if (document.querySelector(".size-chart-btn")) {
  const btn = document.querySelector(".size-chart-btn");
  const overlay = document.getElementById("sizeChartOverlay");
  const closeBtn = document.querySelector(".size-chart-close");

  if (overlay && closeBtn) {
    btn.addEventListener("click", () => {
      overlay.style.display = "flex";
    });

    closeBtn.addEventListener("click", () => {
      overlay.style.display = "none";
    });

    overlay.addEventListener("click", (e) => {
      if (e.target === overlay) {
        overlay.style.display = "none";
      }
    });
  }
}




 document.querySelectorAll('.variant-button-group').forEach(group => {
      const buttons = group.querySelectorAll('.variant-button');
      const hiddenInput = group.querySelector('.variant-select');

      buttons.forEach(button => {
        button.addEventListener('click', () => {
          // Remove active class from all buttons
          buttons.forEach(btn => btn.classList.remove('active'));
          // Add active to clicked button
          button.classList.add('active');
          // Set hidden input value
          hiddenInput.value = button.dataset.variantId;
        });
      });

      // ✅ Automatically select the first variant button
      const firstButton = buttons[0];
      if (firstButton && hiddenInput) {
        firstButton.classList.add('active');
        hiddenInput.value = firstButton.dataset.variantId;
      }
    });

document.getElementById('open-complete-look').addEventListener('click', function () {
    document.getElementById('complete-look-modal').style.display = 'flex';
  });

  document.querySelector('.close-complete-look').addEventListener('click', function () {
    document.getElementById('complete-look-modal').style.display = 'none';
  });

  document.getElementById('add-complete-look-to-cart').addEventListener('click', function () {
    const variantSelectors = document.querySelectorAll('.variant-select');
    const items = [];

    variantSelectors.forEach(select => {
      const variantId = select.value;
      if (variantId) {
        items.push({
          id: variantId,
          quantity: 1
        });
      }
    });

    if (items.length > 0) {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
      .then(res => res.json())
      .then(data => {
        console.log('Added to cart:', data);
        window.location.href = '/cart';
      })
      .catch(error => {
        console.error('Error adding to cart:', error);
      });
    }
  });






if (document.querySelector(".product-detail__media .grid-cols")) {
  if (window.innerWidth < 768) {  
    $('.product-detail__media .grid-cols').slick({
      dots: false,
      infinite: false,
      speed: 500,
      autoplay: false,
      autoplaySpeed: 3000,
      arrows: true,
      slidesToShow: 1,
      slidesToScroll: 1
    });
  }
}








});